export default __webpack_public_path__ + "static/media/settings.a191f14a.svg";